import { jsx as _jsx } from "react/jsx-runtime";
import { createHashRouter } from 'react-router';
import { MainLayout } from './layouts/MainLayout/MainLayout';
import { ProtectedRoute } from './components/ProtectedRoute/ProtectedRoute';
import { LoginPage } from './pages/login/Login';
import { MyCoursesPage } from './pages/my-courses/MyCourses';
import { HistoryPage } from './pages/history/History';
import { DigitalMediaPage } from './pages/digital-media/DigitalMedia';
import { HelpCenterPage } from './pages/help-center/HelpCenter';
import { CourseDetailsPage } from './pages/course-details/CourseDetails';
export const routes = [
    {
        path: "/login",
        element: _jsx(LoginPage, {}),
    },
    {
        element: _jsx(ProtectedRoute, {}),
        children: [
            {
                element: _jsx(MainLayout, {}),
                children: [
                    {
                        path: "/",
                        element: _jsx(MyCoursesPage, {}),
                    },
                    {
                        path: "/my-courses",
                        element: _jsx(MyCoursesPage, {}),
                    },
                    {
                        path: "/history",
                        element: _jsx(HistoryPage, {}),
                    },
                    {
                        path: "/digital-media",
                        element: _jsx(DigitalMediaPage, {}),
                    },
                    {
                        path: "/help-center",
                        element: _jsx(HelpCenterPage, {}),
                    },
                    {
                        path: "/course-details",
                        element: _jsx(CourseDetailsPage, {}),
                    },
                ],
            },
        ],
    },
];
export const router = createHashRouter(routes);
//# sourceMappingURL=routes.js.map